// ═══════════════════════════════════════════════════════════════════
//  modules/chat/SujFiltres.js
//  statut, catégorie, tri, occurrences, recherche
//
//  Sorti de SujPanel.js le 7 aout 2026. Le JSX est celui d'origine,
//  deplace au caractere pres ; les props sont calculees par analyse
//  de portee, pas devinees.
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../../socle/theme";
import { CATEGORY_LABELS } from "../projets/constantes";
import { SUJ_CATEGORIES, SUJ_CATEGORIE_IDS, SUJ_STATUTS, SUJ_TRIS } from "./constantes";
import { SujChip } from "./SujChip";
import { SujFilterRow } from "./SujFilterRow";

export function SujFiltres({ categorie, data, maxOcc, occMin, qInput, setCategorie, setOccMin, setQ, setQInput, setSince, setSort, setStatut, since, sort, statut }) {
  return (
    <>
      {/* ── 4. FILTRES ──────────────────────────────────────────────── */}
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        <SujFilterRow label="Statut">
          {SUJ_STATUTS.map((s) => <SujChip key={s.id} active={statut === s.id} onClick={() => setStatut(s.id)}>
            {s.label}{data && data.par_statut && data.par_statut[s.id] != null ? ` (${data.par_statut[s.id]})` : ""}
          </SujChip>)}
        </SujFilterRow>

        <SujFilterRow label="Catégorie">
          <SujChip active={!categorie} onClick={() => setCategorie("")}>Toutes</SujChip>
          {SUJ_CATEGORIE_IDS.map((id) => {
            const m = SUJ_CATEGORIES[id];
            return <SujChip key={id} active={categorie === id} color={m.color} onClick={() => setCategorie(categorie === id ? "" : id)}
              title={m.tache ? `Génère une tâche « ${CATEGORY_LABELS[m.tache].label} »` : "Rapport seulement"}>{m.icon} {m.label}</SujChip>;
          })}
        </SujFilterRow>

        <SujFilterRow label="Tri">
          {SUJ_TRIS.map((t) => <SujChip key={t.id} active={sort === t.id} onClick={() => setSort(t.id)}>{t.label}</SujChip>)}
        </SujFilterRow>

        <SujFilterRow label="Occ. min">
          <input type="range" min={1} max={maxOcc} value={Math.min(occMin, maxOcc)} onChange={(e) => setOccMin(Number(e.target.value))}
            style={{ width: 180, accentColor: THEME.gold }} />
          <span style={{ color: THEME.text, fontSize: 12, fontWeight: 700 }}>≥ {occMin}</span>
          <span style={{ color: THEME.textDim, fontSize: 11 }}>/ {maxOcc}</span>
          {occMin > 1 && <SujChip onClick={() => setOccMin(1)}>réinitialiser</SujChip>}
        </SujFilterRow>

        <SujFilterRow label="Dernière occ.">
          <input type="date" value={since} onChange={(e) => setSince(e.target.value)}
            style={{ background: THEME.surface, border: `1px solid ${THEME.border}`, color: THEME.text, borderRadius: 8, padding: "6px 10px", fontSize: 12, outline: "none" }} />
          {since && <SujChip onClick={() => setSince("")}>effacer</SujChip>}
          <div style={{ display: "flex", gap: 6, marginLeft: "auto" }}>
            <input value={qInput} onChange={(e) => setQInput(e.target.value)} onKeyDown={(e) => e.key === "Enter" && setQ(qInput)}
              placeholder="Rechercher dans les titres…"
              style={{ background: THEME.surface, border: `1px solid ${THEME.border}`, color: THEME.text, borderRadius: 8, padding: "6px 12px", fontSize: 12, outline: "none", minWidth: 180 }} />
            <button onClick={() => setQ(qInput)} style={{ background: THEME.accentDim, border: `1px solid ${THEME.accent}`, color: THEME.accent, borderRadius: 8, padding: "6px 12px", cursor: "pointer", fontSize: 12, fontWeight: 700 }}>🔍</button>
          </div>
        </SujFilterRow>
      </div>
    </>
  );
}
